module.exports = __webpack_public_path__ + "static/christmas-gift-54874825b8fb6492f956bbe9f5451434.svg";